import type * as Monaco from 'monaco-editor';

export const LIGHT_JAVASCRIPT_LANGUAGE = 'javascript-light';

interface LanguageModule {
  conf: Monaco.languages.LanguageConfiguration;
  language: Monaco.languages.IMonarchLanguage;
}

interface LazyLanguage extends Monaco.languages.ILanguageExtensionPoint {
  loader?: () => Promise<LanguageModule>;
}

// Own id, because Monaco starts its TypeScript worker for 'javascript'.
export function registerLightJavascript(): void {
  const monaco = (window as unknown as { monaco?: typeof Monaco }).monaco;
  const languages: LazyLanguage[] = monaco?.languages.getLanguages() ?? [];
  const javascript = languages.find((language) => language.id === 'javascript' && language.loader);
  if (!javascript || languages.some((language) => language.id === LIGHT_JAVASCRIPT_LANGUAGE)) {
    return;
  }
  monaco.languages.register({ id: LIGHT_JAVASCRIPT_LANGUAGE });
  monaco.languages.registerTokensProviderFactory(LIGHT_JAVASCRIPT_LANGUAGE, {
    create: async () => (await javascript.loader()).language,
  });
  monaco.languages.onLanguageEncountered(LIGHT_JAVASCRIPT_LANGUAGE, async () => {
    monaco.languages.setLanguageConfiguration(LIGHT_JAVASCRIPT_LANGUAGE, (await javascript.loader()).conf);
  });
}
